export const setToken = ( state, token ) => {
    localStorage.setItem("EXC-token", token);
    state.token = token;
    setHeaders(state, token);
}

export const setRefreshToken = ( state, refreshToken ) => {
    localStorage.setItem("EXC-refreshToken", refreshToken);
    state.refreshToken = refreshToken
}

export const setClient = ( state, client ) => {
    localStorage.setItem("EXC-clientName", client);
}

export const setUrlBack = ( state, urlBack ) => {
    localStorage.setItem("EXC-urlBack", urlBack)
}

export const setHeaders = ( state, token ) => {
    state.config.headers.Authorization = "Bearer " + token;
}
